import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";

interface WithSpiffCounts {
  total_amount: number;
}

const PaymentAmountCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  id: "payment-amount",
  header: "Payment amount",
  accessorFn: (row) => row.total_amount,
  cell: ({ getValue }) => {
    const amount = getValue() as number;
    return <div>{formatMoney(amount) ?? "$0"}</div>;
  },
  enablePinning: true,
});

export default PaymentAmountCol;
